import { EDealType } from '../types/dealType';

export const TABS = [
  {
    value: EDealType.Sale,
    label: 'Оценка стоимости',
  },
  {
    value: EDealType.Rent,
    label: 'Арендная ставка',
  },
];
